import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFound = ({
  title,
  description,
  detail,
  primaryLabel,
  primaryTo = "/home",
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(primaryTo);
  };

  return (
    <section className="min-h-[calc(100vh-244px)] px-4 py-10 tablet:px-8 desktop:px-10 desktop:py-14">
      <div className="mx-auto max-w-[1280px]">
        <div
          className="relative overflow-hidden rounded-[32px] border border-SKF-G-003 bg-SKF-G-005 px-6 py-10 text-left shadow-[0_20px_80px_rgba(0,0,0,0.35)] tablet:px-10 tablet:py-12 desktop:px-16 desktop:py-16"
          style={{
            backgroundImage:
              "linear-gradient(135deg, rgba(76,155,248,0.16) 0%, rgba(26,26,29,0) 38%), linear-gradient(320deg, rgba(248,148,76,0.12) 0%, rgba(26,26,29,0) 30%)",
          }}
        >
          <div
            className="pointer-events-none absolute -left-8 bottom-[-48px] h-36 w-36 rounded-full blur-3xl"
            style={{ background: "rgba(76, 155, 248, 0.22)" }}
          />
          <div
            className="pointer-events-none absolute right-0 top-0 h-44 w-44 rounded-full blur-3xl"
            style={{ background: "rgba(248, 148, 76, 0.14)" }}
          />
          <span className="pointer-events-none absolute right-4 top-4 text-[72px] font-black leading-none text-white/[0.05] mobile:text-[56px] tablet:text-[96px] desktop:right-8 desktop:top-6 desktop:text-[180px]">
            404
          </span>

          <div className="relative z-10 max-w-[720px]">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-SKF-Blue-001">
              {t("notFound.label")}
            </p>
            <h1 className="m-0 text-4xl font-semibold text-white mobile:text-3xl desktop:text-6xl">
              {title || t("notFound.title")}
            </h1>
            <p className="mb-0 mt-4 max-w-[560px] text-base leading-7 text-SKF-G-001 mobile:text-sm mobile:leading-6">
              {description || t("notFound.description")}
            </p>

            {detail && (
              <div className="mt-6 inline-flex rounded-full border border-SKF-G-003 bg-black/20 px-4 py-2 text-sm text-SKF-G-001">
                {detail}
              </div>
            )}

            <div className="mt-8 flex flex-wrap gap-3 justify-center desktop:justify-start">
              <Button
                type="primary"
                icon={<HomeOutlined />}
                onClick={() => navigate(primaryTo)}
                className="!h-11 !rounded-full !border-0 !bg-SKF-Blue-001 !px-6 !font-semibold !text-white hover:!bg-[#76B7FF]"
              >
                {primaryLabel || t("notFound.goHome")}
              </Button>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={handleGoBack}
                className="!h-11 !rounded-full !border-SKF-G-003 !bg-transparent !px-6 !text-white hover:!border-SKF-G-001 hover:!text-white"
              >
                {t("notFound.goBack")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
